<template>
  <div class="medical-insurance-tab">
    <!-- 暂无数据提示 -->
    <div class="empty-data-container">
      <div class="empty-icon">
        <i class="el-icon-first-aid-kit"></i>
      </div>
      <div class="empty-text">暂无医保数据</div>
      <div class="empty-description">当前没有相关的医保信息记录</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MedicalInsuranceTab',
}
</script>

<style lang="less" scoped>
.medical-insurance-tab {
  width: 100%;
  height: 100%;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-data-container {
  text-align: center;
  padding: 20px 20px;

  .empty-icon {
    margin-bottom: 16px;
    
    i {
      font-size: 48px;
      color: #d9d9d9;
      transition: all 0.3s ease;
      
      &:hover {
        color: #bfbfbf;
        transform: scale(1.05);
      }
    }
  }

  .empty-text {
    font-size: 16px;
    font-weight: 500;
    color: #595959;
    margin-bottom: 6px;
    line-height: 1.4;
  }

  .empty-description {
    font-size: 13px;
    color: #8c8c8c;
    line-height: 1.5;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .empty-data-container {
    padding: 15px 15px;
    
    .empty-icon i {
      font-size: 36px;
    }
    
    .empty-text {
      font-size: 14px;
    }
    
    .empty-description {
      font-size: 12px;
    }
  }
}
</style>